<template>
  <div :class="{container: true, empty: list && list.length === 0}">
    <input id="copyUrlInput" type="text">
    <div class="filter-container">
      <div class="btn-container">
        <!-- <p v-show="upload_role.normal_upload&&user_space.is_upload_enabled" id="httpUpBtn" class="green" style="display: flex"> -->
        <p v-show="upload_role.normal_upload&&user_space && user_space.is_upload_enabled"  v-click-outside="closeUploadList" @click="showUploadList = true" class="green" style="display: flex">
          <i class="add"></i>
          <span>本地上传</span>

          <span v-show="showUploadList" class="uplaodList">
            <!-- <span @click="localUpload">本地上传</span> -->
            <span @click="newlocalUpload">本地上传</span>
          </span>
        </p>
        <p v-if="upload_role.normal_upload && user_space && !user_space.is_upload_enabled" @click="$fullTitle({title: '您的草稿空间已满', msg: '请在”我的素材“或草稿文稿中清除素材'})" class="green" style="display: flex">
          <i class="add"></i>
          <span>本地上传</span>
        </p>
        <!-- <p v-show="upload_role.aspera_upload&&user_space.is_upload_enabled" @click="checkFailTime=0;checkAspera()"> -->
        <p v-show="upload_role.aspera_upload && user_space && user_space.is_upload_enabled" @click="netUpload">
          <i class="lightning"></i>
          <span>高速上传</span>
        </p>
        <p v-if="upload_role.aspera_upload && user_space && !user_space.is_upload_enabled" @click="$fullTitle({title: '您的草稿空间已满', msg: '请在”我的素材“或草稿文稿中清除素材'})" class="green" style="display: flex">
          <i class="lightning"></i>
          <span>高速上传</span>
        </p>
        <!-- <p>
                    <img src="@assets/img/material/weixin.svg" alt="">
                    <span>微信上传</span>
                </p> -->
        <img class="notice" src="@assets/img/material/notice.svg" alt="">
        <div class="format-notice">
          <p class="title">格式</p>
          <span>{{ materialFiletypes }} </span>
          <p class="content">单个素材不超过<span>{{materialMaxSize}}GB。</span></p>
        </div>
      </div>
      <div class="filter-content">
        <div class="status">
          <p><span>状</span><span>态</span></p>
          <ul>
            <li @click="stateIndex=index" v-for="(item,index) in stateList" :key="index" :class="stateIndex === index ? 'green' : ''">{{item}}</li>
          </ul>
        </div>
        <div class="status">
          <p><span>类</span><span>型</span></p>
          <ul>
            <li @click="typeIndex=index" v-for="(item,index) in typeList" :key="index" :class="typeIndex === index ? 'green' : ''">{{item}}</li>
          </ul>
        </div>
        <div class="date">
          <div class="left-container">
            <p><span>日</span><span>期</span></p>
            <ul>
              <li @click="dateIndex=index" v-for="(item,index) in dateList" :key="index" :class="dateIndex === index ? 'green' : ''">{{item}}</li>
            </ul>
          </div>
          <div class="right-container">
            <date-picker v-show="dateIndex === 0" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
            </date-picker>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'material-container': true, on: selectList.length > 0}">
      <div class="select-container">
        <div class="left-container">
          <!-- <div @click="selectAll=!selectAll;clickSelectAll()" class="select-content">
            <div :class="selectAll ? 'on' : ''"></div>
            <p>
              全选
              <span>（已选择{{num}}个素材）</span>
            </p>
          </div>
          <div class="btn-container">
            <p v-if="create.material||create.report||create.publish" @click="changeShowMission" :class="{green: true, on: Number(num)>0}">
              创建
            <ul v-click-outside="closeShowMission" v-if="showMission">
              <li v-if="create.material" @click="navigate('material')">
                <i class="uploadIcon"></i>
                <span>上传线索</span>
              </li>
              <li v-if="create.report" @click="navigate('report')">
                <i class="reportIcon"></i>
                <span>创建报道</span>
              </li>
              <li v-if="create.publish" @click="navigate('publish')">
                <i class="publicIcon"></i>
                <span>创建发布</span>
              </li>
            </ul>
            </p>
            <p v-if="quickEdit" :class="{green: true, on: Number(num)>0}" @click="useDetail()">选用</p>
            <p :class="{green: true, on: Number(num)>0}" @click="delDetail()">删除</p>
          </div> -->
        </div>
        <div class="right-container">
          草稿空间（{{user_space && user_space.used_GB}}G/{{user_space && user_space.quota_GB}}G)
        </div>
      </div>
      <div class="list-container">
        <empty :mTop="30" v-if="list && list.length === 0 && !waiting" :msg="'暂无素材'" />
        <skeleton v-show="waiting" mediaType="media"></skeleton>
        <ul v-show="!waiting" class="list-content" ref="list">
          <li @mouseenter="showTwoBtn(index)" @mouseleave="hideTwoBtn(index)" v-for="(item,index) in list" :key="index" :style="'height:'+itemHeight+'px'" :class="{list: true, on: item.status, border: item.editStatus}">
            <div :style="'height:'+itemImgHeight+'px'" class="cover">
              <div class='verify-success verify-item' v-if="item.has_audit&&item.has_audit==1&&+item.type === 2">
                <img class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                技审通过
              </div>

              <div class='verify-fail verify-item' v-if="item.has_audit&&item.has_audit==2&&+item.type === 2">
                <img class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
                技审未通过
              </div>
              <div @click="openDetail(item.type, item.id, index)" class="bg" v-if="item.type-0 === 1 || item.type-0 === 2" :style="{'background-image': `url(${item.cover || defaultImg})`}"></div>
              <div @click="openDetail(item.type, item.id, index)" class="bg" v-if="item.type-0 === 3" :style="{'background-image': `url(${item.cover || defaultMedia})`}"></div>
              <img @click="openDetail(item.type, item.id, index)" v-show="item.type-0 === 2 || item.type-0 === 3" class="playBtn" src="@assets/img/index/play.svg" alt="">
              <!-- <img v-show="item.is_new-0 === 1&&item.status === false" :class="{newIcon: true, on: item.editStatus}" src="@assets/img/common/new-bold.svg" alt=""> -->
              <div @click="item.status=!item.status;calcSelect();setSelected(item)" :class="{selectIcon: true, on: item.status, show: item.editStatus}"></div>
              <div @click="item.showMenu = !item.showMenu;checkPos(index)" :class="{pointIcon: true, on: item.showMenu}"></div>
              <ul v-show="item.showMenu" class="pointList">
                <li>
                  <span>创建</span>
                  <i v-show="$store.state.create.material||$store.state.create.report||$store.state.create.publish || libraryCreateList.length || netdiskSaveList.length"></i>
                  <div :class="{left: item.showLeft}">
                    <ul>
                      <li v-for="(v, i) in libraryCreateList" :key="i" @click="v.click([item.id])">
                        <span>{{ v.title }}</span>
                      </li>
                      <li v-for="(v, i) in netdiskSaveList" :key="'disk' + i" @click="v.click([item.id])">
                        <span>{{ v.title }}</span>
                      </li>
                      <li v-show="$store.state.create.material" @click="navigate('material',item.id)">
                        <span>上传线索</span>
                      </li>
                      <li v-show="$store.state.create.report" @click="navigate('report',item.id)">
                        <span>创建报道</span>
                      </li>
                      <li v-show="$store.state.create.publish" @click="navigate('publish',item.id)">
                        <span>创建发布</span>
                      </li>
                      <li v-show="$store.state.create.new_media" @click="navigate('new_media',item.id)">
                        <span>新媒体发布</span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role || item.detail.has_publish_quality_download_role) && item.type != 1 && item.type != 3">
                  <span>下载</span>
                  <i></i>
                  <div :class="{left: item.showLeft}">
                    <ul>
                      <li @click="downloadSource(item,0)" v-if="item.detail.has_low_quality_download_role">
                        <span>800K码流下载</span>
                      </li>
                      <li @click="downloadSource(item,2)" v-if="item.detail.has_publish_quality_download_role">
                        <span>发布码流下载</span>
                      </li>
                      <li @click="downloadSource(item,1)" v-if="item.detail.has_high_quality_download_role">
                        <span>原始码流下载</span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li @click="downloadSource(item,1)" v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type == 1">
                  <span>下载</span>
                </li>
                <li @click="downloadSource(item,1)" v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type == 3">
                  <span>下载</span>
                </li>
                <li v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type != 1 && item.type != 3">
                  <span>复制</span>
                  <i></i>
                  <div :class="{left: item.showLeft}">
                    <ul>
                      <li @click="copySource(item,0)" :class="{un: !item.detail.low_quality_copy_available}" v-if="item.detail.has_low_quality_copy_role">
                        <span>800K码流复制</span>
                      </li>
                      <li @click="copySource(item,1)" v-if="item.detail.has_high_quality_copy_role">
                        <span>原始码流复制</span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li @click="copySource(item,1)" v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type == 1">
                  <span>复制</span>
                </li>
                <li @click="copySource(item,1)" v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type == 3">
                  <span>复制</span>
                </li>
                <li style="margin: 0;justify-content: center" @click="rename(item)">
                  <span style="margin: 0">重命名</span>
                </li>
                <li @click="delDetail(item.id)">
                  <span>删除</span>
                </li>
                <li v-if="item.type == 2 && $store.state.quickEdit && item.detail.edit_role" @click="edit(item,item.type)">
                  <span>编辑</span>
                </li>
                <li v-if="item.type != 2 && item.detail.edit_role" @click="edit(item,item.type)">
                  <span>编辑</span>
                </li>
                <li v-if="$store.state.quickEdit" @click="useDetail(item.id)">
                  <span>选用</span>
                </li>
                <li v-if="item.has_stream_send && item.user_status == 1" @click="mediaSend(item.id)">
                  <span>归档</span>
                </li>
                <li v-if="item.has_share" @click="$ShareCode(item.id)">
                  <span>分享</span>
                </li>
              </ul>
              <!-- <div class="mask">
                <div @click="delDetail(item.id)" class="whiteBg del">
                  <i></i>
                </div>
                <div @click="openDetail(item.type, item.id, index)" class="whiteBg detail">
                  <i></i>
                </div>
              </div> -->
            </div>
            <div :class="{detail: true,on: item.editStatus}">
              <p @click="openDetail(item.type, item.id, index)" class="title">
                <img v-show="item.type-0 === 1" src="@assets/img/common/imgIcon.svg" alt="img">
                <img v-show="item.type-0 === 3" src="@assets/img/common/audioIcon.svg" alt="img">
                <img v-show="item.type-0 === 2" src="@assets/img/common/videoIcon.svg" alt="img">
                <span>{{item.title}}</span>
              </p>
              <div :class="{detail: true, on: item.editStatus}">
                <p class="clock">
                  <img src="@assets/img/material/clockIcon.svg" alt="">
                  <span>{{item.raw_add_time}}</span>
                </p>
                <p class="share">
                  <img src="@assets/img/material/shareIcon.svg" alt="">
                  <span>被引用 {{item.use_num}}</span>
                  <span v-if="item.use_list && item.use_list.length > 0" class="tips">
                    <p class="tip" @click.stop="goRptDtl(el)" v-for="(el,key) in item.use_list" :key="key">
                      <img v-if="el.use_type == 'report'" src="@assets/img/common/reportIcon.svg">
                      <img v-if="el.use_type == 'publish'" src="@assets/img/common/uploadIcon.svg">
                      <img v-if="el.use_type == 'new_media'" src="@assets/img/common/uploadIcon.svg">
                      <img style="margin-left: 1.5px;margin-right: 11.5px" v-if="el.use_type == 'material'" src="@assets/img/common/materialIcon.svg">
                      <i class="tiptitle">{{el.title}}</i>
                      <i class="tiper">{{el.username}}</i>
                      <i class="tiptime">{{el.raw_update_time}}</i>
                    </p>
                  </span>
                </p>
                <p class="source">
                  <img src="@assets/img/material/sourceIcon.svg" alt="">
                  <span>{{item.source_info && item.source_info.ptitle}}</span>
                </p>
              </div>
            </div>
          </li>
          <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
        </ul>
      </div>
      <pages style="margin-top: 6px;padding: 0" :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
    </div>
    <div v-show="selectList.length > 0" :style="'left: '+footLineGap+'px;width: calc(100vw - '+footLineGap+'px)'" class="bottom">
      <div class="left-container">
        <div @click="selectAll1" :class="{selectBtn: true,on: isSelectAll}"></div>
        <div @click="selectAll1" class="selectWord">
          全选
          <span>（已选择{{selectList.length}}个素材）</span>
        </div>
        <div class="btn-container">
          <div v-click-outside="closeBottomBtn">
            <span @click="showBottomBtn = !showBottomBtn">创建</span>
            <ul v-show="showBottomBtn">
              <li v-for="(v, i) in libraryCreateList" :key="i" @click="v.click(selectList.map(v=>v.id));showBottomBtn = false">
                <span>{{ v.title }}</span>
              </li>
              <li v-for="(v, i) in netdiskSaveList" :key="'disk' + i" @click="v.click(selectList.map(v=>v.id));showBottomBtn = false">
                <span>{{ v.title }}</span>
              </li>
              <li v-show="$store.state.create.material" @click="navigate('material');showBottomBtn = false">
                <span>上传线索</span>
              </li>
              <li v-show="$store.state.create.report" @click="navigate('report');showBottomBtn = false">
                <span>创建报道</span>
              </li>
              <li v-show="$store.state.create.publish" @click="navigate('publish');showBottomBtn = false">
                <span>创建发布</span>
              </li>
              <li v-show="$store.state.create.new_media" @click="navigate('new_media');showBottomBtn = false">
                <span>新媒体发布</span>
              </li>
            </ul>
          </div>
          <div v-show="$store.state.quickEdit" @click="useDetail">选用</div>
          <div v-show="$store.state.has_stream_send && showGD" @click="mediaSendAll">归档</div>
          <div @click="delDetail()" v-show="path != 'index'">删除</div>
        </div>
      </div>
      <div class="right-container">
        <p @click="cancelAll">取消选择</p>
      </div>
    </div>

    <div ref="unifiedContentLibraryCustomRef"></div>
  </div>
</template>

<script>
import common from "@common/common";
import * as config from "@common/config";
import pages from "@components/pages";
import empty from "@components/empty";
import skeleton from "@components/skeleton";
import DatePicker from "vue2-datepicker";
import vClickOutside from "v-click-outside";
import store from "@common/store";
import { loadMicroApp } from "qiankun";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { pages, empty, DatePicker, skeleton },
  watch: {
    selectList: {
      handler(e) {
        console.log(e)
        let arr = []
        let length = e.length;
        e.forEach(el => {
          if(el.has_stream_send){
            arr.push(1)
          }
        })
        if(arr.length == length){
          this.showGD = true
        }else{
          this.showGD = false
        }
      },
      immediate: true,
      deep: true
    },
    setflashPic1: {
      handler(e) {
        console.log(e)
        if(e){
          this.page.pageIndex = 1;
          this.getList()
        }
      },
      immediate: true,
      deep: true
    },
    randomDate: {
      handler(e) {
        console.log(e)
        if(e){
          this.page.pageIndex = 1;
          this.getList()
        }
      },
      immediate: true,
      deep: true
    },
    "$store.state.user_space": function (to) {
      // console.log(to)
      this.user_space = to;
    },
    "$store.state.quickEdit": function (to) {
      this.quickEdit = to;
    },
    "$store.state.create": function (to) {
      this.create = to;
    },
    "$store.state.scrollHide": function (to) {
      if(to){
        this.calcFillWidth()
      }
    },
    datePicker: {
      deep: true,
      handler: function (n) {
        this.page.pageIndex = 1;
        this.start = common.stampToTime(n[0]);
        this.end = common.stampToTime(n[1]);
        this.getList();
      }
    },
    stateIndex(to) {
      this.page.pageIndex = 1;
      this.getList();
    },
    typeIndex(to) {
      this.page.pageIndex = 1;
      this.getList();
    },
    dateIndex(to) {
      if (to != 0) {
        this.start = "";
        this.end = "";
        this.datePicker = "";
      }
      this.page.pageIndex = 1;
      this.getList();
    },
    addFilePromises: {
      deep: true,
      handler: function (n) {
        const leftWithoutPending = this.file.list.filter(
          l => !l.pending && !l.hideasset
        ).length;

        Promise.all(n).then(() => {
          if (leftWithoutPending === 0) {
            console.log("真真真真真真真真上传完成");
            this.uploading = false;
            this.page.pageIndex = 1;
            this.getList();
            // this.passUploading();
            // this.$emit("getComplete", "");
          }
        });
      }
    }
  },
  computed: {
    setflashPic1() {
      return this.$store.state.flashPic1
    },
    randomDate() {
      return this.$store.state.randomDate
    },
    
  },
  data() {
    return {
      showUploadList: false,
      materialFiletypes: 'jpg,jpeg,png,gif,mpg,vob,avi,mp4,wmv,f4v,rmvb,flv,mkv,webm,ogv,3gp,ts,m2t,m4v,mov,asf,mxf,mp3,wav',
      materialMaxSize: 10,
      showGD: true,
      showBottomBtn: false,
      isSelectAll: false,
      selectList: [],
      path: '',
      selectListNum: 0,
      footLineGap: 230,
      waiting: true,
      user_space: {},
      checkFailTime: 0,
      upload_role: {},
      download_role: {},
      searchOptions: {},
      showDownLoad: false,
      showMission: false,
      quickEdit: true,
      create: {
        interview: false,
        material: false,
        publish: false,
        report: false
      },
      messageList: [],
      uploading: false,
      baseUrl: "",
      appId: "",
      appSecret: "",
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/audioMask.jpg"),
      datePicker: "",
      fillWidth: 0,
      itemHeight: 0,
      itemImgHeight: 0,
      page: {
        pageCount: 0,
        pageSize: 50,
        pageIndex: 1,
        total: 0
      },
      qkPage: {
        pageIndex: 1,
        pageSize: 10
      },
      stateList: ["全部", "草稿", "已发布"],
      stateIndex: 0,
      typeList: ["全部", "图片", "视频", "音频"],
      typeIndex: 0,
      dateList: ["全部", "今天", "昨天", "前一周"],
      dateIndex: 0,
      list: [],
      start: "",
      end: "",
      num: 0,
      selectAll: false,
      baseConfig: {
        customered: true,
        autoUploading: true,
        multipleFiles: true,
        retryCount: 3,
        tokenURL: "",
        uploadURL: "",
        postVarsPerFile: {
          appId: "",
          appSecret: ""
        },
        onMaxSizeExceed: f => {
          this.$toast("文件大小超出限制");
        },
        onCancel: f => {
          console.log("cancel", f);
        },
        onExtNameMismatch: () => {
          this.$toast("无法上传不支持的格式");
        }
      },
      pic: {
        // 图片部分数据模型
        types: [],
        assets: []
      },
      video: {
        // 视频部分数据模型
        types: [],
        assets: []
      },
      audio: {
        // 音频部分数据模型
        types: [],
        assets: []
      },
      file: {
        // 文件部分数据模型
        title: "文件",
        description: "",
        stream: null,
        list: [],
        cancelOne: f => {
          if (f.pending) {
            this.deleteAsset(f.idstring, this.file.list);
            return;
          }

          if (this.file.stream) {
            try {
              this.file.stream.cancelOne(f.id);
            } catch (error) {
              console.log("stream取消出错", error);
            }

            this.delItem(this.file.list, f.id);
          }
        },
        config: {
          browseFileId: "httpUpBtn",
          extFilters: [],
          maxSize: 10 * 1024 * 1024 * 1024,
          onQueueComplete: m => {
            // this.$toast('所有文件已上传完成')
            // this.uploading = false
            // this.passUploading()
          },
          onComplete: f => {
            let messageIndex = null;
            this.file.stream.cancelOne(f.id);

            f.targetPath = JSON.parse(f.msg).targetPath;

            let messageList = Array.from(new Set(this.messageList));

            messageList = messageList.filter(el => {
              return el.status_name != "正在上传";
            });

            this.$store.commit("setMessageList", messageList);

            this.file.list.forEach(i => {
              if (i.id === f.id) {
                i.targetPath = f.targetPath;
                this.$set(i, "hideasset", true);
                this.$set(i, "typeName", "上传成功");
              }
            });

            // this.addAssetsToPage([f])
            this.addFilePromises.push(this.addAssetsToPage([f]));
          },
          onUploadError: f => {
            this.$toast("文件上传出错");
          },
          onSelect: f => {
            // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
            setTimeout(() => {
              f = this.filterFiles(f, this.file.config.maxSize);

              f.forEach(el => {
                console.log(el);
                el.type_name = "上传素材";
                el.status_name = "正在上传";
                el.msg = name;
                el.type = 0;
                el.status = 0;
                this.messageList.unshift(el);
              });

              this.$store.commit("setMessageList", this.messageList);

              let totalList = this.file.list.concat(f);
              const allTypes = this.pic.types
                .concat(this.video.types)
                .concat(this.audio.types);
              totalList = totalList.filter(i => allTypes.indexOf(i.ext) > -1);
              this.file.list = Array.from(new Set(totalList));
            }, 0);
          },
          onUploadProgress: f => {
            this.uploading = true;
            // this.passUploading();
            // this.handleProgress(this.file.list, f);
          }
        }
      },
      aspera: {
        // aspera通道上传
        needInstall: false,
        files: [],
        filetypes: [],
        maxSize: 10 * 1024 * 1024 * 1024,
        checkInstalled: null,
        config: {
          host: "",
          userName: "",
          userPassword: "",
          deviceID: ""
        },
        start: f => {
          console.log("aspera uploading", f);
          const current = {
            remote_host: this.aspera.config.host,
            remote_user: this.aspera.config.userName,
            remote_password: common.hex2str(this.aspera.config.userPassword),
            create_dir: true,
            direction: "send",
            needs_destination: "",
            paths: [
              {
                fileId: f.id,
                fileName: f.filename,
                source: f.name,
                destination: f.serverpath
              }
            ]
          };
          const params = {
            allow_dialogs: false
          };

          fileControls.asperaWeb.startTransfer(current, params, {
            error: responseData => {
              let userMessage = responseData.error.user_message;
              this.$toast(userMessage);
            },
            success: res => {
              console.log("start", res);
              this.messageList.unshift({
                type_name: "上传素材",
                status_name: "正在上传",
                type: 0,
                status: 0,
                fileId: res.transfer_specs[0].transfer_spec.paths[0].fileId,
                name: res.transfer_specs[0].transfer_spec.paths[0].fileName
              });
              this.$store.commit("setMessageList", this.messageList);
            }
          });
        },
        complete: f => {
          f.targetPath = f.serverpath;
          //   this.messageList.forEach(el => {
          //     if (el.fileId === f.id) {
          //       this.$set(el, "typeName", "上传成功");
          //     }
          //   });
          let messageList = Array.from(new Set(this.messageList));

          messageList = messageList.filter(el => {
            return el.status_name != "正在上传";
          });
          this.$store.commit("setMessageList", messageList);
          this.file.list.forEach(i => {
            if (i.id === f.id) {
              this.$set(i, "hideasset", true);
            }
          });
          // this.addAssetsToPage([f])
          this.addFilePromises.push(this.addAssetsToPage([f]));
        },
        delete: f => {
          // 删除上传过程中的文件
          if (f.pending) {
            this.deleteAsset(f.idstring, this.file.list);
            return;
          } else {
            fileControls.asperaWeb.removeTransfer(f.uuid);
            this.delItem(this.file.list, f.id);
          }
        }
      },
      addFilePromises: [],
      hasHttp: false,
      hasAspera: false,
      file_format_types: {},
      libraryCreateList: [],
      netdiskSaveList: []
    };
  },
  methods: {
    closeUploadList() {
      this.showUploadList = false;
    },
    mediaSend(id) {
      let info = {
          subject_type: 10,
          subject_id: id
      };
      common
      .myFetch(config.apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    mediaSendAll() {
      let id = [];
      this.selectList.forEach(el => {
        id.push(el.id)
      })
      id = id.join(',')
      let info = {
          subject_type: 10,
          subject_id: id
      };
      common
      .myFetch(config.apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    closeBottomBtn() {
      this.showBottomBtn = false;
    },
    renameAsset(item,el) {
      if (!el.name) return;
      const info = {
        idstring: el.idstring,
        title: el.name
      };

      common.myFetch(config.apis.File_rename, info).then(r => {
        if (r) {
          this.$toast(r);
          // item.title = el.name
        }
      });
    },
    rename(item) {
      let content = {}
      content.title = item.title
      content.idstring = item.detail.idstring
      this.$Rename(content).then(el => {
        if(el){
          // console.log(el)
          this.renameAsset(item,el)
        }
      })
    },
    setIsSelectAll(e) {
      this.isSelectAll = e;
    },
    cancelAll() {
      this.isSelectAll = false;
      this.selectList = [];
      this.list.forEach(el => {
        el.status = false;
      })
    },
    selectAll1() {
      this.isSelectAll = !this.isSelectAll;
      if(this.isSelectAll){
        this.selectList = [];
        this.list.forEach(el => {
          el.status = true;
          this.selectList.push(el)
        })
      }else{
        this.selectList = []
        this.list.forEach(el => {
          el.status = false;
        })
      }
    },
    setSelectList(e) {
      this.selectListNum = e.length
    },
    setSelected(item) {
      if(item.status){
        this.selectList.push(item)
      }else{
        this.selectList = this.selectList.filter(el => {
          return el.id != item.id
        })
      }
      let length = this.list.length;
      console.log(length,this.selectList.length)
      if(this.selectList.length != length){
        this.isSelectAll = false;
      }else{
        this.isSelectAll = true;
      }
    },
    edit(detail,type) {
      if (type - 0 === 1) {
        this.editPic(detail);
      } else if (type - 0 === 2) {
        let info = {
          title: detail.title,
          id: detail.id
        }
        this.$cloudEditConfirm(info).then((res) => {
          if(res != 999){
            window.open(res.meisheurl)
          }
        })
        // console.log(this.detail)
      } else if (type - 0 === 3) {
        this.editVideo(detail.detail.text_status, detail);
      }
    },
    editVideo(i, j) {
      console.log(i, j);
      let newObj = {
        pageType: null,
        pageId: null,
        file_format: j.detail.upload.url,
        appId: j.detail.upload.app_id,
        appSecret: j.detail.upload.app_secret
      };
      Object.assign(j, newObj);
      this.$voiceEditType(i, j).then(res => {
        console.log(res, i);
        if (res == 0 && i == 3 && res !== false) {
          // console.log(this.pageType,this.$route.query.d,j)
          const newWindow = window.open();
          // console.log(`${window.location.origin}/voiceEdit/${this.pageType}/${this.$route.query.d}/${j.idstring}`)
          newWindow.location.href = `${window.location.origin
            }/voiceEdit/${this.pageType}/${this.pageId}/${j.detail.idstring
            }`;
        } else if (res == "peComplete") {
          this.test();
        }
      });
    },
    test() {

    },
    editPic(i) {
      i.t = null;
      i.d = i.id;
      i.url = i.detail.url;
      this.$picEditType1(i, this.test).then(el => {
        if (Number(el) == '123') {
          this.getList()
        }
      });
    },
    showTwoBtn(index) {
      this.$set(this.list[index], 'isOn', true)  
    },
    hideTwoBtn(index) {
      if(!this.list[index].isSelected){
        this.$set(this.list[index], 'isOn', false)
      }  
      this.$set(this.list[index], 'showMenu', false)
      this.$set(this.list[index], 'showLeft', false)
    },
    checkPos(e) {
      let offsetLeft = document.documentElement.clientWidth - document.querySelectorAll('.list-content > li')[e].offsetLeft
      if(offsetLeft < 400){
        this.$set(this.list[e], 'showLeft', true)
      }
    },
    localUpload() {
      // let httpUpBtn1 = document.getElementById('myUploadBtn');
      let httpUpBtn1 = document.getElementById('httpUpBtn1');
      console.log(httpUpBtn1)
      httpUpBtn1.click()
    },
    newlocalUpload() {
      // let httpUpBtn1 = document.getElementById('myUploadBtn');
      let httpUpBtn1 = document.getElementById('myUploadBtn');
      console.log(httpUpBtn1)
      httpUpBtn1.click()
    },
    netUpload() {
      let httpUpBtn2 = document.getElementById('httpUpBtn224');
      console.log(httpUpBtn2)
      httpUpBtn2.click()
    },
    showEditDetail(index) {
      this.list.forEach((el,key) => {
        if(index === key){
          el.editStatus = true
        }
      })
    },
    hideEditDetail(index) {
      this.list.forEach((el,key) => {
        if(index === key){
          el.editStatus = false
        }
      })
    },
    goRptDtl({ use_type, id }) {
      if (use_type == "report") {
        common.jump(`/reportDetail?d=${id}`, true);
      } else if (use_type == "publish") {
        common.jump(`/publishDetail?d=${id}`, true);
      } else if (use_type == "material") {
        common.jump(`/clueDetail?d=${id}`, true);
      } else if (use_type == "new_media") {
        common.jump(`/mediaPublishDetail?d=${id}`, true);
      }
    },
    download(type) {
      this.list.forEach(el => {
        if (el.status) {
          this.downloadSource1(el, type);
        }
      });
    },
    closeShowMission() {
      this.showMission = false;
    },
    closeShowDownLoad() {
      this.showDownLoad = false;
    },
    changeShowMission() {
      if (this.num > 0) {
        this.showMission = true;
      } else {
        this.$toast("请选择素材");
      }
    },
    changeShowDownLoad() {
      if (this.num > 0) {
        this.showDownLoad = true;
      } else {
        this.$toast("请选择素材");
      }
    },
    async navigate(type,ids) {
      let arr = [];
      let id = "";
      this.list.forEach(el => {
        if (el.status) {
          arr.push(el.id);
        }
      });
      if (arr.length > 0) {
        id = arr.join(",");
        if (type === "interview") {
          common.jump("/newInterview", true);
        } else if (type === "material") {
          let info = {
            id: id,
            push_to: type,
            type: 0
          };
          common.myFetch(config.apis.File_filepush, info).then(r => {
            if (r) {
              common.jump(`/creatClue?t=0&d=${r.id}`, true);
            }
          });
        } else if (type === "report") {
          const typeName = await this.$pageType();
          if (!typeName) return;
          let info = {
            id: id,
            push_to: type,
            type: typeName
          };
          common.myFetch(config.apis.File_filepush, info).then(r => {
            if (r) {
              common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
            }
          });
        } else if (type === "publish") {
          const typeName = await this.$pageType("publish");
          if (!typeName) return;
          let info = {
            id: id,
            push_to: type,
            type: typeName
          };
          common.myFetch(config.apis.File_filepush, info).then(r => {
            if (r) {
              common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
            }
          });
        } else if (type === "new_media") {
          const typeName = await this.$MediaPlatform();
          if (!typeName) return;
          let info = {
          file_ids: id,
          subject_type: 5,
          subject_id: typeName
        };
          common.myFetch(config.apis.File_bind, info).then(r => {
            if (r) {
              common.jump(`/createMediaPublish?d=${typeName}`, true);
            }
          });
        }
      } else {
        if (type === "material") {
          let info = {
            id: ids,
            push_to: type,
            type: 0
          };
          common.myFetch(config.apis.File_filepush, info).then(r => {
            if (r) {
              common.jump(`/creatClue?t=0&d=${r.id}`, true);
            }
          });
        } else if (type === "report") {
          const typeName = await this.$pageType();
          if (!typeName) return;
          let info = {
            id: ids,
            push_to: type,
            type: typeName
          };
          common.myFetch(config.apis.File_filepush, info).then(r => {
            if (r) {
              common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
            }
          });
        } else if (type === "publish") {
          const typeName = await this.$pageType("publish");
          if (!typeName) return;
          let info = {
            id: ids,
            push_to: type,
            type: typeName
          };
          common.myFetch(config.apis.File_filepush, info).then(r => {
            if (r) {
              common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
            }
          });
        } else if (type === "new_media") {
          const typeName = await this.$MediaPlatform();
          if (!typeName) return;
          let info = {
            file_ids: ids,
            subject_type: 5,
            subject_id: typeName
          };
          common.myFetch(config.apis.File_bind, info).then(r => {
            if (r) {
              common.jump(`/createMediaPublish?d=${typeName}`, true);
            }
          });
        }
        // if (type === "interview") {
        //   common.jump("/newInterview", true);
        // } else if (type === "material") {
        //   common.jump("/creatClue?t=0", true);
        // } else if (type === "report") {
        //   const typeName = await this.$pageType();
        //   if (!typeName) return;
        //   common.jump(`/creatReport?t=${typeName}`, true);
        // } else if (type === "publish") {
        //   const typeName = await this.$pageType("publish");
        //   if (!typeName) return;
        //   common.jump(`/createPublish?t=${typeName}`, true);
        // }
      }
    },
    loadJQ() {
      if (window.$) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.jqjs);
    },
    loadAW4() {
      if (window.AW4) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.aw4js);
    },
    loadAW4Config() {
      if (window.AW4.ConnectInstaller) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.aw4config);
    },
    loadAspera() {
      return Promise.all([this.loadJQ(), this.loadAW4()]).then(() => {
        return this.loadAW4Config().then(() => {
          return this.loadAsperaJS();
        });
      });
    },
    loadAsperaJS() {
      // 加载js文件
      if (window.fileControls) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.asperajs);
    },
    resetAsperaCheck() {
      // 重置aspera检测，恢复初始状态
      if (this.aspera.checkInstalled) {
        clearTimeout(this.aspera.checkInstalled);
        this.aspera.checkInstalled = null;
        this.$set(this.aspera, "needInstall", false);
      }
    },
    __parseFileName(path) {
      // 解析文件路径中的文件名
      if (/Win/.test(navigator.platform)) {
        return path.substring(path.lastIndexOf("\\") + 1);
      } else {
        return path.substring(path.lastIndexOf("/") + 1);
      }
    },
    generateServerPath(f) {
      // 生成服务器端路径
      let serverpath = "";
      const uniname = common.uniKey();
      const platform = common.getPlatform();
      const ext = f.filename.split(".").pop();
      const asperaPath = window._XN_upCfg.asperaPath;
      const fileNameId = window._XN_upCfg.fileNameId;
      const path = `${asperaPath}/${fileNameId}${platform}${uniname}.${ext}`;
      f.id = uniname;
      serverpath = path;

      return serverpath;
    },
    asperaUpload() {
      if (this.uploading) return;
      fileControls.asperaWeb.showSelectFileDialog({
        success: res => {
          const files = [];

          res.dataTransfer.files.forEach(i => {
            if (i.size <= this.aspera.maxSize) {
              console.log(i);
              let ext = i.name.split(".").pop();
              ext = ext.toLowerCase();
              // const types = this.aspera.filetypes
              if (this.aspera.filetypes.indexOf(ext) === -1) {
                this.$toast("无法上传不支持的格式");
              } else {
                i.filename = this.__parseFileName(i.name);
                i.serverpath = this.generateServerPath(i);
                i.percent = 0;
                files.push(i);
              }
            } else {
              this.$toast("上传文件不能超出限制");
            }
          });

          this.aspera.files = files;
          this.file.list = this.aspera.files.concat(this.file.list);
          if (this.aspera.files.length > 0) {
            this.uploading = true;
          }
          this.aspera.files.forEach(f => {
            this.aspera.start(f);
          });
        }
      });
      // fileControls.showSelectFileDialog(document.body, config, moid, userid, true);
    },
    checkAspera() {
      // let checkFailTime = 0;
      this.$set(this.aspera, "needInstall", true);
      this.loadAspera().then(() => {
        const container = $(document.body);
        fileControls.initAsperaConnect(container, (installed, updatable) => {
          // 检测aspera插件是否安装可用
          console.log(installed);
          if (!installed) {
            // this.$toast('请安装aspera客户端')
            this.$set(this.aspera, "needInstall", true);
            this.checkFailTime++;
            this.aspera.checkInstalled =
              this.aspera.checkInstalled ||
              setTimeout(() => {
                this.checkAspera();
              }, 1000);

            if (this.checkFailTime == 5) {
              clearTimeout(this.aspera.checkInstalled);
              this.aspera.checkInstalled = null;
              this.$confirm(
                "未检测到高速上传插件，暂时无法使用该服务是否前往下载该插件？"
              ).then(r => {
                if (r) {
                  window.open(config.asperapage, true);
                }
              });
            }
          }

          if (updatable) {
            this.$toast("请升级到最新客户端");
          }

          if (installed) {
            this.$set(this.aspera, "needInstall", false);
            this.resetAsperaCheck();
            this.asperaUpload();

            fileControls.asperaWeb.addEventListener("transfer", (e, status) => {
              if (status.result_count <= 0) return;
              const filelist = status.transfers.filter(
                i => i.current_file || i.status == "completed"
              );
              this.handleAsperaProgress(filelist);
            });
          }
          // 检测aspera插件是否安装可用
        });
      });
    },
    handleAsperaProgress(list) {
      // console.log(list)
      this.file.list.forEach(i => {
        list.forEach(j => {
          if (!i.hideasset && i.filename === j.title) {
            if (j.status === "failed") {
              this.$toast(j.error_desc);
              return;
            }

            // this.$set(i, "percent", j.percentage * 100);
            // this.$set(i, "total", this.rcsDvs(j.bytes_expected));
            // this.$set(i, "loaded", this.rcsDvs(j.bytes_written));
            // this.$set(i, "title", j.title);
            // this.$set(i, "uuid", j.uuid);
            if (j.status === "completed") {
              this.aspera.complete(i);
              console.log("complete", i);
            }
          }
        });
      });
    },
    filterFiles(f, size) {
      // 大小超出的文件删除出去
      let files = [];
      files = f.filter(i => {
        return i.size < size;
      });

      files.forEach(el => {
        el.fileId = el.id;
      });

      this.file.list.forEach((j, k) => {
        let idx = files.length - 1;
        while (idx >= 0) {
          if (files[idx].name === j.name && !j.pending && !j.hideasset) {
            this.$toast("请不要同时上传相同的文件");
            files.splice(idx, 1);
          }

          idx -= 1;
        }
      });

      return files;
    },
    checkFileType(f) {
      // 检查文件类型
      let type = "";
      let ext = f.name.split(".").pop() || f.path.split(".").pop();
      ext = ext.toLowerCase();

      if (this.pic.types.indexOf(ext) > -1) {
        type = 1;
      } else if (this.video.types.indexOf(ext) > -1) {
        type = 2;
      } else if (this.audio.types.indexOf(ext) > -1) {
        type = 3;
      }

      return type;
    },
    async addAssetsToPage(data) {
      console.log(data);
      const filelist = [];
      data.forEach(i => {
        const type = this.checkFileType(i);
        // 将文件名改为截取前40位加后缀名
        const fileName = i.pureName || i.title || i.filename || i.name || "";
        const nameParts = fileName.split(".");
        const ext = nameParts.pop();
        let nameLeft = nameParts.join(".");
        nameLeft = nameLeft.substr(0, 40);
        const filetitle = `${nameLeft}.${ext}`;

        const file = {
          type: type,
          title: filetitle,
          path: i.targetPath || i.path
        };

        filelist.push(file);
      });

      const info = { file_info: JSON.stringify(filelist) };
      return common.myFetch(config.apis.File_add, info).then(r => {
        if (r) {
          // this.getFileAssets();
        }
      });
    },
    delItem(data, id) {
      // 从数组中移除取消上传的项
      data.forEach((d, i) => {
        if (d.id === id) {
          data.splice(i, 1);
        }
      });
    },
    deleteAsset(idstring, list) {
      // 删除资源文件
      const info = {
        idstring: idstring
      };
      common.myFetch(config.apis.File_delete, info).then(r => {
        if (r) {
          this.$toast(r);

          list.some((d, i) => {
            if (d.idstring === idstring) {
              list.splice(i, 1);
              // 通知编辑器 删除 该素材
              // this.$emit("deleteMedia", {
              //     src: d.url,
              //     idstring,
              //     type: this.navOn
              // });
              return true;
            }
          });
        }
      });
    },
    convertByteToGb(n) {
      // 将字节转换为GB
      return n / 1024 / 1024 / 1024;
    },
    getMaxSize() {
      common.myFetch(config.apis.File_Aspera).then(r => {
        if (r) {
          const types = r.file_format;

          const filetypes = types.image.concat(types.video).concat(types.audio);

          this.materialFiletypes = filetypes.join(',')

          let maxSize = r.file_format.file_size || this.file.config.maxSize;

          this.materialMaxSize = this.convertByteToGb(maxSize)

        }
      });
    },
    getAsperaConfig() {
      // 获取aspera上传配置
      return common.myFetch(config.apis.File_Aspera).then(r => {
        if (r) {
          const types = r.file_format;
          this.file_format_types = types;
          this.hasHttp = r.normal_upload;
          this.hasAspera = r.aspera_upload;
          this.pic.types = types.image;
          this.video.types = types.video;
          this.audio.types = types.audio;
          // window._XN_upVdoTps = types.video // 视频格式前缀为source，此处为传入streamjs
          this.aspera.config = r.upload_config;
          const filetypes = types.image.concat(types.video).concat(types.audio);
          this.aspera.filetypes = filetypes;
          const extFilters = filetypes.map(f => `.${f}`);
          this.file.config.extFilters = extFilters;

          this.file.config.maxSize =
            r.file_format.file_size || this.file.config.maxSize;
          this.aspera.maxSize = r.file_format.file_size || this.aspera.maxSize;

          this.file.description = `素材格式：${filetypes.join(
            ","
          )} <br><br> 视频、音频每种素材不超过10个，单个素材不超过${this.convertByteToGb(
            this.aspera.maxSize
          )}GB`;

          window._XN_upCfg = {
            asperaPath: r.aspera_path,
            httpPath: r.original_path,
            fileNameId: r.filename_id
          };
        }
      });
    },
    loadjs() {
      // 加载js文件
      if (window.Stream) {
        return new Promise((r, j) => {
          r(true);
        });
      }

      return common.load(config.streamjs);
    },
    load() {
      // 加载js文件
      // return common.load(config.streamjs)
      return this.getAsperaConfig().then(() => {
        return Promise.all([this.loadjs(), this.getConfig()]);
      });
    },
    getConfig() {
      return common.getFileConfigs().then(r => {
        this.baseUrl = r.url;
        this.appId = r.app_id;
        this.appSecret = r.app_secret;

        const dataConfig = {
          tokenURL: this.baseUrl + config.apis.File_get_token,
          uploadURL: this.baseUrl + config.apis.File_post,
          postVarsPerFile: {
            appId: this.appId,
            appSecret: this.appSecret
          }
        };

        Object.assign(this.baseConfig, dataConfig);
        return true;
      });
    },
    openDetail(type, id, index) {
      if (!this.list[index].trans_finish) {
        this.$toast("转码中，暂时无法预览");
        return;
      }
      this.list[index].is_new = false;
      let data = {
        type: type,
        id: id,
        create: this.create,
        canEdit: true,
        quickEdit: this.quickEdit,
        isMyMaterial: true,
        libraryCreateList: this.libraryCreateList,
        netdiskSaveList: this.netdiskSaveList
      };
      this.$materialBox(data, this.changeTitleImage);
    },
    changeTitleImage(info) {
      console.log(info)
      if(info){
        this.list.forEach(el => {
          if(el.id == info.id){
            this.$set(el, 'title', info.title)
          }
        })
      }
    },
    useDetail(id) {
      let data = {
        file_ids: ""
      };

      let arr = [];
      this.list.forEach(el => {
        if (el.status) {
          arr.push(el.id);
        }
      });

      if (arr.length > 0) {
        data.file_ids = arr.join(",");
        common.myFetch(config.apis.File_addquickfile, data).then(res => {
          if (res) {
            this.$toast("已成功加入选用素材");
            this.$store.commit("setQuickEditNum", res.quick_edit_num);
          }
        });
      } else {
        data.file_ids = id;
        common.myFetch(config.apis.File_addquickfile, data).then(res => {
          if (res) {
            this.$toast("已成功加入选用素材");
            this.$store.commit("setQuickEditNum", res.quick_edit_num);
          }
        });
      }
    },
    async delDetail(id) {
      let msg = `确认删除素材？`;
      const confirm = await this.$confirm(msg);
      if(!confirm) return
      let data = {
        file_ids: ""
      };
      if (id) {
        data.file_ids = id;
      } else {
        let arr = [];
        this.list.forEach(el => {
          if (el.status) {
            arr.push(el.id);
          }
        });
        console.log(arr)
        data.file_ids = arr.join(",");
      }
      if (data.file_ids) {
        common.myFetch(config.apis.File_delmyfile, data).then(res => {
          if (res) {
            this.$toast(res);
            this.cancelAll();
            this.getList();
          }
        });
      } else {
        this.$toast("请选择素材");
      }
    },
    clickSelectAll() {
      if (this.selectAll) {
        this.num = this.list.length;
        this.list.forEach(el => {
          el.status = true;
        });
      } else {
        this.num = 0;
        this.list.forEach(el => {
          el.status = false;
        });
      }
    },
    calcSelect() {
      let num = 0;
      this.list.forEach(el => {
        if (el.status) {
          num++;
        }
      });
      if (num === this.list.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
      this.num = num;
    },
    getList() {
      this.waiting = true;
      let data = {
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        key_words: "",
        search_option: "",
        type: this.typeIndex,
        days: this.dateIndex,
        start: this.start,
        end: this.end,
        status: this.stateIndex
      };

      this.searchOptions.key_words = this.$store.state.keyWord

      Object.assign(data, this.searchOptions)

      common.myFetch(config.apis.File_myFile, data).then(res => {
        // console.log(res)
        this.$set(
          this.page,
          "pageCount",
          common.calculatePage(res.page.row_count - 0, this.page.pageSize)
        );

        this.$store.commit('setSelectList',[])

        this.selectList = this.$store.state.selectList

        this.$set(this.page, "total", res.page.row_count - 0);
        this.download_role = res.download_role;
        this.upload_role = res.upload_role;
        res.list.forEach(el => {
          el.editStatus = false;
          el.status = false;
          el.showMenu = false;
          el.showLeft = false;
          el.isOn = false;
          el.isSelected = false;
        });
        this.generateSearchs(res.params.top_search.option.list)
        this.num = 0;
        this.selectAll = false;
        this.list = res.list;
        this.$store.commit("setUserSpace", res.user_space);

        this.$nextTick(() => {
          this.waiting = false;
          setTimeout(() => {
            this.calcFillWidth();
          })
        })
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    calcFillWidth() {
      // console.log(999)
      // 计算填充元素宽度
      const list = this.$refs.list;
      if (!list || !list.getBoundingClientRect()) return;
      const listWidth = list.getBoundingClientRect().width;
      let fillWidth = 0;
      const itemWidth = 255; // item dom宽度
      const itemGap = 12; //item 边距
      const listGap = 12; // list左右边距
      const countsPerPage = this.list.length || 20; //每页的item数量
      const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
      const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
      const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
      const itemRatio = 284.5 / 255;
      const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
      const itemHeightNow = itemWidthNow * itemRatio;

      fillWidth =
        countsPerRow === countsLastLine
          ? 0
          : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);

      this.fillWidth = fillWidth;
      this.itemHeight = (((listWidth/countsPerRow)-14)*9/16)+135;
      this.itemImgHeight = (((listWidth/countsPerRow)-14)*9/16);
      // this.itemHeight = itemHeightNow;
      // console.log('list', itemWidthNow, itemHeightNow, countsPerRow, fillWidth)
    },
    addCalcEvent() {
      // 监听list dom宽度变化
      window.addEventListener("resize", () => {
        this.calcFillWidth();
      });
    },
    configFile() {
      // 配置文件
      const config = Object.assign({}, this.baseConfig, this.file.config, common.userKeys());

      this.file.stream = new Stream(config);
    },
    init() {
      // 模块初始化
      this.load().then(() => {
        // this.configPic()
        // this.configVideo()
        // this.configAudio()
        this.configFile();
      });
    },
    getTranscode(r) {
      // 获取视音频入库状态
      const info = r.content;
      if (info) {
        this.$toast(`${info.title}已入库`);
        this.getList();
      }
    },
    downloadSource(source, type) {
      if (type === 0) {
        if (!this.download_role.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.content.status != 1) {
            this.$toast("转码尚未完成");
            return;
          }
        }
      } else if (type === 1) {
        if (!this.download_role.has_high_quality_download_role && source.type == 2) {
          this.$toast("无下载权限");
          return;
        }
      }

      const info = {
        idstring: source.detail.idstring || source.id,
        file_quality: type || 0
        // subject_type: 0,
        // subject_id: this.$route.query.d
      };
      const url = config.apis.File_download;
      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      common.exportRes(url, params, 1);
    },
    copySource(source, type) {
      console.log(source)
      if(type === 0){
        if(!source.detail.low_quality_copy_available){
          this.$toast("转码中暂无法复制链接");
          return;
        }
      }
      // return false;
      let data = {
        id: source.id,
        type: type
      };

      // console.log(config.apis.materialCopy)

      common.myFetch(config.apis.materialCopy, data).then(res => {
        console.log(res)
        let dom = document.getElementById('copyUrlInput')
        dom.value = res.copy_url;
        dom.select()
        document.execCommand("Copy");
        this.$toast("复制成功");
      });
    },
    downloadSource1(source, type) {
      if (type === 0) {
        if (!this.download_role.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.content.status != 1) {
            this.$toast("转码尚未完成");
            return;
          }
        }
      } else if (type === 1) {
        if (!this.download_role.has_high_quality_download_role) {
          this.$toast("无下载权限");
          return;
        }
      }

      let a = document.createElement('a') // 创建a标签
      let e = document.createEvent('MouseEvents') // 创建鼠标事件对象
      e.initEvent('click', false, false) // 初始化事件对象
      a.href = source.cover // 设置下载地址
      a.download = '' // 设置下载文件名
      a.target = "_blank"
      a.dispatchEvent(e)

      // const info = {
      //   idstring: source.id,
      //   file_quality: type || 0
      //   // subject_type: 0,
      //   // subject_id: this.$route.query.d
      // };
      // const url = config.apis.File_download;
      // const userKeys = common.userKeys();
      // const params = Object.assign({}, info, userKeys);

      // common.exportRes(url, params);
    },
    // 加载子应用
    loadSubApp() {
      const timeStr = Date.now();
      const entryPath =
        process.env.NODE_ENV === "production"
          ? `${window.origin}/libraryCustom/`
          : "//localhost:5176";

      const parentInstance = {
          getUserKeys: () => {
            return common.userKeys();
          },
          getCommon: () => {
            return common;
          },
          getSystemConfig: () => {
            return this.$_syscfg;
          },
          getThis: () => {
            return this;
          },
          getCustomType: () => {
            return 'myMaterial';
          },
          customMyMaterial: {
            setList: (list) => {
              this.libraryCreateList = list
            },
          },
          customNetdiskSave: {
            setList: (list) => {
              this.netdiskSaveList = list
            },
          }

      }

      this.microApp = loadMicroApp(
          {
            name: "unified-content-library_custom",
            entry: entryPath + "?time=" + timeStr,
            container: this.$refs.unifiedContentLibraryCustomRef,
            props: { parentInstance: parentInstance, }
          },
          {
            sandbox: {
              experimentalStyleIsolation: true // 样式隔离
            }
          }
        );
      
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    this.quickEdit = this.$store.state.quickEdit;
    this.user_space = this.$store.state.user_space;
    // this.init();
    this.addCalcEvent();
    this.calcFillWidth();
    this.getList();
    common.handleSocket(this.getTranscode, "transcode");
    common.handleSocket(this.getList, "flashfile");
    this.getMaxSize()
    this.$DownloadMessage().then(el => {
      console.log(el)
      if(el == 'uploadComplete'){
        this.page.pageIndex = 1;
        this.getList();
      }
    })
    this.loadSubApp()
  },
  created() { 
    this.create = this.$store.state.create;
    this.user_space = this.$store.state.user_space;
    this.quickEdit = this.$store.state.quickEdit;
  },
  beforeDestroy() {
    // 组件销毁时手动卸载微应用
    if (this.microApp) {
      this.microApp.unmount();
      this.microApp = null;
      console.log('微应用已卸载');
    }
  }
};
</script>

<style lang="less" src="@assets/css/material/myMaterial.less" scoped>
</style>
